export var NavStyles = function (props) {
    var theme = props.theme, isDisabled = props.isDisabled, isSelected = props.isSelected, isGroup = props.isGroup, isLink = props.isLink, _a = props.navHeight, navHeight = _a === void 0 ? 44 : _a;
    var semanticColors = theme.semanticColors;
    return {
        link: [
            {
                height: navHeight,
                lineHeight: navHeight + "px",
            },
            !isDisabled && {
                selectors: {
                    '.${classNames.compositeLink}:hover &': {
                        backgroundColor: semanticColors.bodyBackgroundHovered,
                    },
                },
            },
            isSelected && {
                backgroundColor: semanticColors.bodyBackgroundChecked,
            },
        ],
        chevronButton: [
            {
                lineHeight: navHeight + "px",
                selectors: {
                    '&:hover': {
                        backgroundColor: semanticColors.bodyBackgroundHovered,
                    },
                    '.${classNames.compositeLink}:hover &': {
                        backgroundColor: semanticColors.bodyBackgroundHovered,
                    },
                },
            },
            isGroup && {
                height: navHeight,
            },
            isLink && {
                height: navHeight - 2,
            },
        ],
        chevronIcon: {
            height: navHeight,
            lineHeight: navHeight + "px",
        },
    };
};
//# sourceMappingURL=Nav.styles.js.map